import { io } from "socket.io-client";
import cookieStorage from "../utilities/cookie_storage";

const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL || "http://localhost:4047";

export const socket = io(SOCKET_URL, {
  autoConnect: false,
  transports: ["websocket", "polling"],
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
  timeout: 20000,
  withCredentials: true,
});

// Errors
socket.on("connect_error", (error) => {
  console.error("Socket connection error:", {
    message: error.message,
    description: error.description,
    type: error.type,
  });
});

socket.on("connect_timeout", () => {
  console.error("Socket connection timeout");
});

// Socket connect function
export const connectSocket = () => {
  const token = cookieStorage.getItem("token");

  if (!token) {
    return;
  }

  socket.auth = { token };

  if (!socket.connected) {
    socket.connect();
  }
};

// Optional better reconnect
export const reconnectSocket = () => {
  const token = cookieStorage.getItem("token");

  if (!token) return;

  socket.auth = { token };

  socket.disconnect();
  socket.connect();
};

export const disconnectSocket = () => {
  if (socket.connected) {
    socket.disconnect();
  }
};

export const emitSocketMessage = (eventName, data) => {
  if (socket.connected) {
    socket.emit(eventName, data);
    return true;
  }
  return false;
};